<template>
    <div>
        <div class="back">
            <img src="./img/beijing.png" alt />
            
        </div>
        <div class="content">
            <div class="title">
                <el-row>
                    <el-col :span="12">
                        <h3>智能制造ERP解决方案</h3>
                        <p>小程序+公众号+后台管理系统</p>
                    </el-col>
                    <el-col :span="12" style="text-align:right">
                        <div class="bottons">解决方案</div>
                    </el-col>
                </el-row>
            </div>
            <h4>核心数据</h4>
            <p class="tests">解决中小企业进度更新、管理混乱的问题，全面提升智能改造工厂全流程运营效率</p>
            <div class="one clear">
                <div class="fl oneItem" v-for="(item,index) in oneData" :key="index">
                    <div class="image">
                        <img :src="item.url" :alt="item.title" />
                    </div>
                    <div class="text">
                        <h3>{{item.title}}</h3>
                        <p>{{item.text}}</p>
                    </div>
                </div>
            </div>

            <h4>产品亮点</h4>
            <p class="tests">深耕行业需求，方案量身定制，敏锐洞察，更具前瞻性</p>
            <div class="core">
                <div class="clear coreItem" v-for="(item,index) in coreData" :key="index">
                    <div class="image">
                        <img :src="item.url" :alt="item.title" />
                    </div>
                    <div class="text">
                        <h4>{{item.title}}</h4>
                        <p>{{item.text}}</p>
                    </div>
                </div>
            </div>

            <h4>我们的优势</h4>
            <p class="tests">革命性的为企业赋能，提升产业业态，共享未来、我们一直在努力</p>
            <div class="clear advantage">
                <div
                    class="advantageItem clear fl"
                    v-for="(item,index) in advantageData"
                    :key="index"
                >
                    <div class="fl image">
                        <img :src="item.url" :alt="item.title" />
                    </div>
                    <div class="fr text">
                        <h3>{{item.title}}</h3>
                        <p>{{item.text}}</p>
                    </div>
                </div>
            </div>

            <h4>服务流程</h4>
            <p class="tests">深圳市同创网络科技致力于为客户打造优质的APP/小程序开发产品</p>
            <img src="./img/004@2x.png" alt="软件定制开发流程" />
            <div class="three">
                <img src="./img/003@2x.png" alt="更多优质解决方案，等你来探索" />
                <div class="advisory">立即咨询</div>
            </div>
        </div>
    </div>
</template>
<script>
import { oneData, coreData, advantageData } from "./testData";
export default {
    data() {
        return {
            coreData,
            oneData,
            advantageData
        };
    }
};
</script>
<style lang="scss" scoped>
.advantage {
    margin-bottom: 40px;
    margin-right: -20px;
    .advantageItem {
        width: 386px;
        margin-right: 20px;
        margin-bottom: 25px;
        text-align: left;
        .image {
            padding: 20px;
            background: #42378f;
            img {
                width: 60px;
                height: 60px;
            }
        }
        h3 {
            font-size: 18px;
            font-weight: bold;
            line-height: 20px;
            color: rgba(52, 52, 52, 1);
            margin-bottom: 10px;
        }
        p {
            width: 276px;
            font-size: 12px;
            font-weight: 400;
            line-height: 20px;
            color: rgba(102, 102, 102, 1);
        }
    }
}
.core {
    margin-bottom: 40px;
    .coreItem {
        margin-bottom: 40px;
        .image {
            height: 420px;
            float: right;
            img {
                width: auto;
                height: 100%;
            }
        }
        .text {
            float: right;
            margin-right: 60px;
            h4 {
                width: 200px;
                height: 80px;
                background: rgba(255, 255, 255, 0.3) url("./img/back.png")
                    no-repeat;
                background-size: 100% 100%;
                font-size: 36px;
                font-weight: bold;
                line-height: 80px;
                color: #42378f;
                margin: 0 auto 47px;
            }
            p {
                width: 347px;
                font-size: 18px;
                font-weight: 400;
                line-height: 30px;
                color: rgba(52, 52, 52, 1);
                word-spacing: 347px;
                text-align: left;
            }
        }
        &:nth-child(odd) {
            .image {
                float: left;
                margin-right: 60px;
            }
            .text {
                float: left;
            }
        }
    }
}

.advisory {
    position: absolute;
    width: 120px;
    height: 40px;
    background: rgba(255, 255, 255, 0.5);
    font-size: 12px;
    font-weight: 400;
    line-height: 40px;
    color: #ffffff;
    bottom: 80px;
    left: calc(50% - 60px);
}
.three {
    position: relative;
    margin: 40px 0 40px;
}
.one {
    margin-bottom: 40px;
    margin-right: -20px;
    .oneItem {
        width: 285px;
        margin-right: 20px;
        .image {
            height: 160px;
            background: #42378f;
            display: flex;
            align-items: center;
            img {
                width: 80px;
                height: 80px;
                margin: 0 auto;
            }
        }
        .text {
            background: #42378f;
            height: 125px;
            h3 {
                font-size: 18px;
                font-weight: bold;
                color: rgba(255, 255, 255, 1);
                padding-top: 10px;
                margin-bottom: 20px;
            }
            p {
                width: 246px;
                font-size: 12px;
                font-weight: 400;
                line-height: 20px;
                color: rgba(255, 255, 255, 1);
                margin: 0 auto;
                word-spacing: 246px;
            }
        }
    }
}

h4 {
    font-size: 36px;
    text-align: center;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 20px;
}
.tests {
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    color: rgba(102, 102, 102, 1);
    margin-bottom: 40px;
}
.back {
    padding-top: 60px;
    height: 360px;
    position: relative;
    width: 100%;
    h2 {
        font-size: 80px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        width: 100%;
        height: 360px;
        line-height: 360px;
        position: absolute;
        top: 60px;
        left: 0;
    }
}
.content {
    width: 1200px;
    margin: 0 auto 80px;
}
.title {
    width: calc(100% - 80px);
    position: relative;
    top: -40px;
    padding: 40px;
    height: 120px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.3);
    p {
        font-size: 12px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        text-align: left;
    }
    h3 {
        font-size: 48px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        text-align: left;
        margin-bottom: 40px;
    }
}
.bottons {
    width: 100px;
    height: 30px;
    border: 1px solid rgba(153, 153, 153, 1);
    border-radius: 15px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 30px;
    text-align: center;
    display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/view/erpManage/index.vue